<div class="tw-flex tw-items-center tw-flex-wrap tw-gap-[8px]">
  <span>{{ 'iss-wo-common.recurrence-schedule.labels.recur-every' | translate }}</span>
  <ng-content/>
  <span>{{ 'iss-wo-common.recurrence-schedule.every-recurrence-type.week' | translate }} {{ 'iss-wo-common.recurrence-schedule.labels.on' | translate }}</span>
  <ng-content select="[formControlName='weeklyRecurrenceDayNames']"/>
</div>
